import React from 'react'
import { RouteObject } from 'react-router-dom'
import { MainLayout } from '@components/layout/MainLayout'
import { lazyWithSuspense } from '@app/utils/routeUtils'
import { MK_RESORTS_PATH } from '@constants'

export const resortRoutes: RouteObject[] = [
  // Route with promoHeader (resorts listing)
  {
    path: `${MK_RESORTS_PATH}`,
    element: (
      <MainLayout
        themeSwitcher
        promoHeader
      />
    ),
    children: [
      {
        index: true,
        element: lazyWithSuspense(() => import('@pages/resort/PageResort')),
      },
    ],
  },
  // Route without promoHeader (individual resort details with location)
  {
    path: `${MK_RESORTS_PATH}/:location/:resortKey`,
    element: <MainLayout themeSwitcher />,
    children: [
      {
        index: true,
        element: lazyWithSuspense(() => import('@pages/resort/PageResort')),
      },
    ],
  },
]
